import React, { createContext, useContext } from 'react';

interface PDFContextType {
  isPDF: boolean;
  currentPage?: string;
}

const PDFContext = createContext<PDFContextType>({
  isPDF: false,
});

export const usePDFContext = () => useContext(PDFContext);

interface PDFProviderProps {
  children: React.ReactNode;
  isPDF?: boolean;
  currentPage?: string;
}

export const PDFProvider: React.FC<PDFProviderProps> = ({ 
  children, 
  isPDF = false, 
  currentPage 
}) => {
  return (
    <PDFContext.Provider value={{ isPDF, currentPage }}>
      {children}
    </PDFContext.Provider>
  );
};
